@if (['lg', 'xl', 'xxl', 'xxxl'].includes(sizeService.screenSize)) {
  @switch (currentViewSetting().view) {
    @case ('list') {
      <button
        sb-button-primary
        [icon]="'pools'"
        [color]="'blue'"
        [iconButton]="true"
        type="button"
        (click)="setViewSetting('card')"
        container="body"
        [ngbTooltip]="'lang.tableWrapper.switchToCardView'|translate" placement="bottom" [openDelay]="2000">
      </button>

    }
    @case ('card') {
      <button
        sb-button-primary
        [icon]="'list'"
        [color]="'blue'"
        [iconButton]="true"
        type="button"
        (click)="setViewSetting('list')"
        container="body"
        [ngbTooltip]="'lang.tableWrapper.switchToListView'|translate" placement="bottom" [openDelay]="2000">
      </button>
    }
    @default {
      <sb-icon icon="loadingBlockAnimation" [hover]="true"></sb-icon>
    }

  }
}
